export enum LevelStatus {
  DONE,
  RECOMMEND,
  STANDBY,
}
